export default "__VITE_ASSET__BVDA2lGm__"